define(function (require, exports, module) {
    'use strict';

    /**
     * @constructor
     * @param {string} hash – облачный hash файла (SHA1 + salt).
     * @param {number} size – размер файла (в байтах).
     * @param {UploadReason|null} error
     */
    function BackendResponseData(hash, size, error) {
        this.hash = hash || '';
        this.size = size || 0;
        this.error = error || null;
    }

    module.exports = BackendResponseData;
});
